import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Element } from '../../../../common/html/element'
import { Radio } from '../../../../common/html/radio'
import { PopupAction } from '../../../../common/popup/PopupAction'
import EventEmitter, {
  SHOW_POPUP_UPGRADE,
} from '../../../../helpers/EventEmitter'
import classes from './index.module.scss'
import {
  addDefault,
  selectCompanyType,
  selectDefaultTemplate,
  selectIsHasCompanyName,
  selectIsHasPortName,
  selectIsHasReportSubtitle,
  selectName,
  selectPanelById,
  selectPanelId,
  selectReportSubtitle,
  selectReportTitle,
} from './store/slice'

const Button = ({
  children,
  action,
  saveTemplate,
  isButtonSave,
  defaultTemplateProp,
  isNotHasPermission,
  disableShowPopupConfirm,
}) => {
  const dispatch = useDispatch()

  const defaultTemplateStore = useSelector(selectDefaultTemplate)
  const panelId = useSelector(selectPanelId)
  const panelById = useSelector(selectPanelById)
  const name = useSelector(selectName)
  const companyType = useSelector(selectCompanyType)
  const reportTitle = useSelector(selectReportTitle)
  const isHasReportSubtitle = useSelector(selectIsHasReportSubtitle)
  const reportSubtitle = useSelector(selectReportSubtitle)
  const isHasCompanyName = useSelector(selectIsHasCompanyName)
  const isHasPortName = useSelector(selectIsHasPortName)

  const defaultTemplate = defaultTemplateProp || defaultTemplateStore

  const placeHolder = UseI18n('preferenceSetting.PLH_INPUT')

  const [isShowPopup, setIsShowPopup] = useState(false)
  const [isShowPopupSaveAs, setIsShowPopupSaveAs] = useState(false)
  const [isSaveAs, setIsSaveAs] = useState(false)
  const [valueInput, setValueInput] = useState('')

  useEffect(() => {
    if (!defaultTemplate.templateId) {
      setIsSaveAs(true)
    }
  }, [defaultTemplate.templateId])

  const showPopupConfirm = () => {
    if (isButtonSave) {
      if (isNotHasPermission) {
        EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
      } else {
        setIsShowPopupSaveAs(true)
      }
    } else if (
      name.trim() === defaultTemplate.templateName &&
      JSON.stringify(panelId) === JSON.stringify(defaultTemplate.panelId) &&
      JSON.stringify(panelById) === JSON.stringify(defaultTemplate.panelById)
    ) {
      action()
    } else {
      setIsShowPopup(true)
    }
  }

  const showPopupSaveAs = () => {
    setIsShowPopupSaveAs(true)
    setIsShowPopup(false)
  }

  const changeInput = (e) => setValueInput(e.target.value)

  const submit = async () => {
    setIsShowPopupSaveAs(false)

    const panels = panelId.map((id) => panelById[id])

    const data = {
      templateName: valueInput.trim(),
      templateData: {
        panels,
        reportTitle,
        isHasReportSubtitle,
        reportSubtitle,
        isHasCompanyName,
        isHasPortName,
      },
      companyType,
    }

    if (!isSaveAs) {
      data.templateId = defaultTemplate.templateId
      data.templateName = defaultTemplateProp?.templateName || name.trim()
    }

    const result = await saveTemplate(data)

    if (result) {
      if (!isSaveAs) {
        dispatch(
          addDefault({
            panelsSelected: panels,
            templateName: data.templateName,
            templateId: data.templateId,
            companyType,
            reportTitle,
            isHasReportSubtitle,
            reportSubtitle,
            isHasCompanyName,
            isHasPortName,
          }),
        )
      }
      action()
    }
  }

  const isDisableSubmit = isSaveAs
    ? !valueInput?.trim()
    : !defaultTemplateProp && !name?.trim()

  return (
    <>
      <div
        onClick={() => {
          if (disableShowPopupConfirm) {
            action()
            return
          }
          showPopupConfirm()
        }}
      >
        {children}
      </div>
      <PopupAction
        isShow={isShowPopup}
        title="preferenceSetting.SAVE_CHANGE"
        handleClose={() => setIsShowPopup(false)}
        btnCancel={{
          label: 'common.NO',
          event: action,
          isI18n: true,
        }}
        btnSubmit={{
          label: 'common.YES',
          event: showPopupSaveAs,
          isI18n: true,
        }}
      >
        <Translate value="preferenceSetting.SAVE_CHANGE_NOTE" />
      </PopupAction>
      <PopupAction
        isShow={isShowPopupSaveAs}
        title="preferenceSetting.SAVE_CHANGE"
        handleClose={() => setIsShowPopupSaveAs(false)}
        btnCancel={{
          label: 'preferenceSetting.CANCEL',
          event: () => setIsShowPopupSaveAs(false),
          isI18n: true,
        }}
        btnSubmit={{
          label: 'preferenceSetting.SAVE',
          event: submit,
          isI18n: true,
          disabled: isDisableSubmit,
        }}
      >
        <Element>
          {defaultTemplate.templateId && (
            <Element>
              <Radio
                title={
                  <>
                    <Translate value="preferenceSetting.SAVE_CHANGE_TO" /> "
                    {defaultTemplate.templateName}"
                  </>
                }
                isI18n={false}
                value={false}
                activeValue={isSaveAs}
                onChange={setIsSaveAs}
                titleStyle={{
                  fontWeight: 600,
                  color: '#3A414B',
                }}
              />
            </Element>
          )}
          <Element style={{ marginTop: defaultTemplate.templateId ? 14 : 0 }}>
            <Radio
              title="preferenceSetting.SAVE_AS"
              value={true}
              activeValue={isSaveAs}
              onChange={setIsSaveAs}
              titleStyle={{ fontWeight: 600, color: '#3A414B' }}
            />
            <Element className="mt1">
              <Element
                elementName="input"
                style={{ border: '1px solid #E0E0E0' }}
                className={classes.inputSaveAs}
                placeholder={placeHolder}
                value={valueInput}
                onChange={changeInput}
              />
            </Element>
          </Element>
        </Element>
      </PopupAction>
    </>
  )
}

Button.propTypes = {
  action: PropTypes.func,
  isButtonSave: PropTypes.bool,
  defaultTemplateProp: PropTypes.object,
  isNotHasPermission: PropTypes.bool,
  disableShowPopupConfirm: PropTypes.bool,
}

Button.defaultProps = {
  action: () => {},
  isButtonSave: false,
  isNotHasPermission: false,
  disableShowPopupConfirm: false,
}

export default Button
